import { Box, TypoTooltip } from '@applift/factor'
import { Conversion } from '../../models/Conversion'
import { MeasurementPartnerAvatar } from '../MeasurementPartnerAvatar'

interface MeasurementPartnerCellProps {
  value: Conversion['partnerName']
  logoUrl: Conversion['postbackPartnerLogoUrl']
}

export const MeasurementPartnerCell = (props: MeasurementPartnerCellProps) => {
  const { value, logoUrl } = props
  if (!value) {
    return <>-</>
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: 100 }}>
      <MeasurementPartnerAvatar logoUrl={logoUrl} name={value || undefined} />
      <TypoTooltip
        arrow
        TypgraphyProps={{ gutterBottom: false }}
        sx={{ ml: 8 }}
      >
        {value}
      </TypoTooltip>
    </Box>
  )
}
